import { useCallback } from 'react';
import UseContext from 'hooks/useContext';

/**
 * Opens the company slide-over from the invoice list: the company of an
 * invoice row, and the company row of the grouped list.
 */
const useOpenCompany = () => {
  const { setObjID, setSlideOverType, setSlideOverShow } = UseContext();
  return useCallback(
    (companyId) => {
      if (!companyId) return;
      setObjID(companyId);
      setSlideOverType('get_company');
      setSlideOverShow(true);
    },
    [setObjID, setSlideOverType, setSlideOverShow],
  );
};

export default useOpenCompany;
